import { isNullOrUndefined } from '../../utils/typeUtils';
// import { primitiveOrArrayExec } from '../../utils/arrayUtils';

const makeNegative = value =>
  value
    .split(' ')
    .map(val => (val.endsWith('rem') || val.endsWith('px') ? `-${val}` : val))
    .join(' ');

export const reverseCssUnits = value => {
  if (Array.isArray(value)) {
    return value.map(string =>
      isNullOrUndefined(string) ? string : makeNegative(string)
    );
  }
  return isNullOrUndefined(value) ? value : makeNegative(value);
};
